module.exports = __webpack_public_path__ + "img/album14_28.e7f750a9.jpg";